import {
  Component,
  Input,
  Output,
  EventEmitter,
  HostListener,
  OnChanges,
  SimpleChanges,
  OnInit,
  computed,
  inject,
} from '@angular/core';
import { NgIf, NgFor, AsyncPipe } from '@angular/common';
import {
  trigger,
  state,
  style,
  transition,
  animate,
} from '@angular/animations';
import { RelativeTimePipe } from "../../pipes/relative-time.pipe";
// import { NotificationHubService } from '../services/notification-hub.services';
import { Notificacion } from '../../../models/notifications.model';
// import { NotificacionService } from '../services/notificacion.service';
import { NotificationService } from '../../../services/notification.service';

@Component({
  selector: 'app-notifications-sidebar',
  standalone: true,
  imports: [NgIf, NgFor, RelativeTimePipe, AsyncPipe],
  templateUrl: './notifications-sidebar.component.html',
  styleUrls: ['./notifications-sidebar.component.scss'],
  animations: [
    trigger('slideInOut', [
      state(
        'in',
        style({
          right: '0',
          opacity: 1,
        })
      ),
      state(
        'out',
        style({
          right: '-400px',
          opacity: 0,
        })
      ),
      transition('out => in', [animate('300ms ease-in')]),
      transition('in => out', [animate('300ms ease-out')]),
    ]),
  ],
})
export class NotificationsSidebarComponent implements OnInit, OnChanges {
  private notificationService = inject(NotificationService);

  @Input() mostrado = false;
  @Output() closeSidebar = new EventEmitter<void>();

  mostrarSoloNoLeidos = false;
  // notificacionesBase: Notificacion[] = [];

  notifications$ = this.notificationService.notifications$;

  notificationsBase: Notificacion[] = [
    { leido: false, mensaje: 'Se le designo como líder del equipo <strong>{nombre del equipo}</strong> al usuario <strong>{Nombre de usuario}</strong>.', titulo: 'Equipos', fecha: new Date('2025-06-13 02:58:00') },
    { leido: false, mensaje: 'El usuario {nombre de usuario} ha seleccionado la actividad {nombre de la actividad} de la iniciativa {nombre de la iniciativa} con fecha de limite {fecha limite}, teniendo en total {numero de actividades en estado no iniciado y en proceso} actividades en estado no iniciado y en proceso.', titulo: 'Iniciativas', fecha: new Date('2025-06-11') },
    { leido: true, mensaje: 'Comentario en ticket', titulo: 'Iniciativas', fecha: new Date('2025-06-10') }
  ];
  
  constructor() {
    // this.notificaciones = this.notificacionesBase;
  }
  ngOnInit(): void {

    

  }
  ngOnChanges(changes: SimpleChanges): void {
    // if (changes['mostrado'] && changes['mostrado'].currentValue === true) {
    //   this.notificaciones$.next(this.notificaciones$.getValue());
    // }
  }

  @HostListener('document:click', ['$event'])
  onOutsideClick(event: MouseEvent) {
    const sidebar = document.getElementById('notifications-sidebar');
    if (this.mostrado && sidebar && !sidebar.contains(event.target as Node)) {
      this.closeSidebar.emit();
    }
  }

  close() {
    this.closeSidebar.emit();
  }

  refrescarLeidos() {
    // this.notificaciones = this.notificacionesBase.filter(n => this.mostrarSoloNoLeidos ? !n.leido : true)
  }

  contarNuevos() {
    // return this.notificaciones.filter(n => !n.leido).length;
  }

}
